'use client';

import { Suspense } from 'react';
import { RecurringPaymentsView } from '@/components/RecurringPaymentsView';
import { PageSkeleton } from '@/components/PageSkeleton';
import { AppHeaderConfig } from '@/contexts/AppHeaderContext';
import { useChatPage } from '@/hooks/useChatPage';

export default function RecurringPaymentsPage() {
  useChatPage('recurring-payments');
  return (
    <div data-onboarding-recurring-page>
      <AppHeaderConfig hidePeriodPicker />
      <Suspense fallback={<PageSkeleton />}>
        <RecurringPaymentsView />
      </Suspense>
    </div>
  );
}
